'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _SimpleButton = require('./generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _Radio = require('./generic/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

var _Checkbox = require('./generic/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Counter = require('./generic/Counter');

var _Counter2 = _interopRequireDefault(_Counter);

var _OrderScheduleScreen = require('./schedule/OrderScheduleScreen');

var _OrderScheduleScreen2 = _interopRequireDefault(_OrderScheduleScreen);

var _Utility = require('../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _CartStore = require('../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _MainStore = require('../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _ScheduleScreenStore = require('../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _cancelButton = require('../../img/cancel-button.png');

var _cancelButton2 = _interopRequireDefault(_cancelButton);

var _ScheduleOrderModal = require('./schedule/ScheduleOrderModal');

var _ScheduleOrderModal2 = _interopRequireDefault(_ScheduleOrderModal);

var _smoothscrollPolyfill = require('smoothscroll-polyfill');

var _smoothscrollPolyfill2 = _interopRequireDefault(_smoothscrollPolyfill);

var _Constants = require('./Constants');

var Constants = _interopRequireWildcard(_Constants);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemOptions = function (_React$Component) {
    _inherits(ItemOptions, _React$Component);

    function ItemOptions(props) {
        _classCallCheck(this, ItemOptions);

        var _this = _possibleConstructorReturn(this, (ItemOptions.__proto__ || Object.getPrototypeOf(ItemOptions)).call(this, props));

        _this.validateOpenHour = function (scheduledDate) {
            var desiredDate = null;

            if (scheduledDate) {
                desiredDate = new Date(scheduledDate.getTime());
            } else {

                // get date time based on the location
                var dateTime = _MainStore2.default.getCurrentDateTime();
                desiredDate = dateTime;
            }

            var msg = null;
            var title = "Do you want to schedule this order?";

            // const locationDetail    = CartStore.getLocationDetail();
            // const locationOpenHours = locationDetail.openHours;
            var orderType = _CartStore2.default.getOrderType();
            // const orderType    =  ScheduleScreenStore.getCurrentOrderType();

            var activeLocationOpenHours = _CartStore2.default.getOnlineOrderingHours();
            /*
            * activeLocationOpenHours should return the openHours corresponding to the selected day
            * */
            var isLocationOpen = Utils.isResturantOpen(activeLocationOpenHours, desiredDate);

            var itemId = null;
            if (_this.props.item.objectId && _this.props.item.objectId != null) {
                itemId = _this.props.item.objectId;
            }

            if (!(orderType == "DineIn")) {
                if (!isLocationOpen) {
                    msg = "This location is closed ";

                    if (scheduledDate) {
                        msg = msg + ' at scheduled time: ' + Utils.formatTime(desiredDate) + '.';
                        title = "Do you want to re-schedule this order ?";
                    } else {
                        msg = msg + ' right now.';
                    }

                    return { title: title, msg: msg };
                }
            }

            var item = _this.props.item;

            var groupDetail = item.groupDetailPointer;
            // console.log("item-Options : validateOpenHours:" +"group details "+groupDetail.openHours + +groupDetail.parentGroup);

            var openHours = _MainStore2.default.getGroupOpenHours(groupDetail, orderType);

            // console.log("item-Options : validateOpenHours: open Hours" + openHours);

            if (!openHours) {
                return { title: title, msg: msg };
            }

            var isGroupOpen = Utils.isResturantOpen(openHours, desiredDate);

            if (!isGroupOpen) {
                msg = 'Item \'' + item.itemName + '\' is not available to order ';
                if (scheduledDate) {
                    msg = msg + ' at scheduled time : ' + Utils.formatTime(scheduledDate) + '. Open hours are: ' + Utils.getOpeningHoursStr(openHours, desiredDate);
                    title = "Do you want to re-schedule this order?";
                } else {
                    msg = msg + ' at this time. Open hours are: ' + Utils.getOpeningHoursStr(openHours, desiredDate) + '.';
                }
            }

            return { title: title, msg: msg };
        };

        _this.state = {
            itemQty: 1,
            itemPrice: 0,
            itemOrderInst: "",
            chosenOptions: [],
            dpItemQty: 1,
            dpItemPrice: 0,
            dpItemOrderInst: "",
            dpChosenOptions: [],
            isOrderSchedulingActive: false
        };

        _this.onQtySelectionChanged = _this.onQtySelectionChanged.bind(_this);
        _this.onTextAreaContentChanged = _this.onTextAreaContentChanged.bind(_this);
        _this.onItemOptionCategoryChanged = _this.onItemOptionCategoryChanged.bind(_this);
        _this.validateChosenOptionCategoryFails = _this.validateChosenOptionCategoryFails.bind(_this);
        _this.generateStillRequiredOptions = _this.generateStillRequiredOptions.bind(_this);
        _this.calculateUnitPrice = _this.calculateUnitPrice.bind(_this);
        _this.getPriorDataForChosenOptions = _this.getPriorDataForChosenOptions.bind(_this);
        _this.bringFocus = _this.bringFocus.bind(_this);
        _this.addUpdateItemToCart = _this.addUpdateItemToCart.bind(_this);
        _this.handleScheduleScreenModal = _this.handleScheduleScreenModal.bind(_this);
        _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
        return _this;
    }

    _createClass(ItemOptions, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {

            var baseOptions = this.props.item.optionCategories || [];
            var requiredOptions = baseOptions.filter(function (option) {
                return option.required;
            });
            var width = window.innerWidth;
            var mobView = width < 993 ? true : false;

            if (this.isItemInCart()) {
                this.setState({
                    chosenOptions: this.props.itemInCart.itemOptionCategories,
                    itemQty: this.props.itemInCart.itemQty,
                    itemOrderInst: this.props.itemInCart.itemOrderInst,
                    itemPrice: this.props.itemInCart.itemPrice,
                    stillRequiredOptions: requiredOptions,
                    requiredOptions: requiredOptions,
                    newOrder: false,
                    dpChosenOptions: [].concat(_toConsumableArray(this.props.itemInCart.itemOptionCategories)),
                    dpItemQty: this.props.itemInCart.itemQty,
                    dpItemPrice: this.props.itemInCart.itemPrice,
                    dpItemOrderInst: this.props.itemInCart.itemOrderInst,
                    isMobile: mobView
                });
            } else {
                this.setState({
                    itemPrice: this.props.item.itemPrice,
                    stillRequiredOptions: requiredOptions,
                    requiredOptions: requiredOptions,
                    newOrder: true,
                    isMobile: mobView
                });
            }

            // Default call the update window dimensions
            //add resize browser window listener
            window.addEventListener("resize", this.updateWindowDimensions);

            // kick off the polyfill!
            _smoothscrollPolyfill2.default.polyfill();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {

            $('#itemOptionModal').modal('hide');

            // Reset the tabindex and again added to 3
            // tabindex 56 is used for the view cart screen
            document.body.tabIndex = 56;
            document.body.focus();
            //remove resize browser window listener
            window.removeEventListener("resize", this.updateWindowDimensions);
        }
    }, {
        key: 'updateWindowDimensions',
        value: function updateWindowDimensions() {

            var width = window.innerWidth;

            this.setState({
                isMobile: width < 993 ? true : false
            });
        }

        // check if the item in the cart or not

    }, {
        key: 'isItemInCart',
        value: function isItemInCart() {

            if (!Utils.isEmptyObj(this.props.itemInCart)) {
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: 'validateDineInOpenHour',
        value: function validateDineInOpenHour(scheduledDate) {

            var desiredDate = null;

            if (scheduledDate) {
                desiredDate = new Date(scheduledDate.getTime());
            } else {

                // get date time based on the location
                var dateTime = _MainStore2.default.getCurrentDateTime();
                desiredDate = dateTime;
            }

            var msg = null;

            //commented by danish
            var orderType = _CartStore2.default.getOrderType();
            // const orderType    =  ScheduleScreenStore.getCurrentOrderType();

            var activeLocationOpenHours = _CartStore2.default.getOnlineOrderingHours();
            /*
            * activeLocationOpenHours should return the openHours corresponding to the selected day
            * */
            var isLocationOpen = Utils.isResturantOpen(activeLocationOpenHours, desiredDate);

            if (!isLocationOpen) {
                msg = "This location is closed right now.";
                return msg;
            }

            var item = this.props.item;
            var groupDetail = item.groupDetailPointer;
            var openHours = _MainStore2.default.getGroupOpenHours(groupDetail, orderType);

            if (!openHours) {
                return;
            }

            var isGroupOpen = Utils.isResturantOpen(openHours, desiredDate);

            if (!isGroupOpen) {
                msg = 'Item \'' + item.itemName + '\' is not available to order ';
                if (scheduledDate) {
                    msg = msg + ' at scheduled time : ' + Utils.formatTime(scheduledDate) + '. Open hours are: ' + Utils.getOpeningHoursStr(openHours, desiredDate);
                } else {
                    msg = msg + ' at this time. Open hours are: ' + Utils.getOpeningHoursStr(openHours, desiredDate) + '.';
                }
            }

            return msg;
        }
    }, {
        key: 'onQtySelectionChanged',
        value: function onQtySelectionChanged(newQty) {
            // update functionality
            if (this.isItemInCart()) {
                this.setState({ dpItemQty: newQty });
            } else {
                this.setState({ itemQty: newQty });
            }
        }
    }, {
        key: 'onTextAreaContentChanged',
        value: function onTextAreaContentChanged(e) {
            // update functionality
            if (this.isItemInCart()) {
                this.setState({ dpItemOrderInst: e.target.value });
            } else {
                this.setState({ itemOrderInst: e.target.value });
            }
        }
    }, {
        key: 'onItemOptionCategoryChanged',
        value: function onItemOptionCategoryChanged(newChosen) {

            // update functionality
            if (this.isItemInCart()) {

                var dpChosenOptions = this.state.dpChosenOptions;

                var chosenIndex = _lodash2.default.findIndex(dpChosenOptions, function (chosenOption) {
                    return chosenOption.category == newChosen.category;
                });

                if (chosenIndex !== -1) {
                    dpChosenOptions[chosenIndex] = newChosen;
                } else {
                    dpChosenOptions.push(newChosen);
                }

                var newItemPrice = this.calculateUnitPrice(dpChosenOptions);
                var stillRequiredOptions = this.generateStillRequiredOptions(dpChosenOptions);
                this.setState({
                    dpChosenOptions: dpChosenOptions,
                    dpItemPrice: newItemPrice,
                    stillRequiredOptions: stillRequiredOptions
                });
            } else {
                // If the item adding new
                var chosenOptions = this.state.chosenOptions;

                var _chosenIndex = _lodash2.default.findIndex(chosenOptions, function (chosenOption) {
                    return chosenOption.category == newChosen.category;
                });

                if (_chosenIndex !== -1) {
                    chosenOptions[_chosenIndex] = newChosen;
                } else {
                    chosenOptions.push(newChosen);
                }

                var _newItemPrice = this.calculateUnitPrice(chosenOptions);
                var _stillRequiredOptions = this.generateStillRequiredOptions(chosenOptions);

                this.setState({
                    chosenOptions: chosenOptions,
                    itemPrice: _newItemPrice,
                    stillRequiredOptions: _stillRequiredOptions
                });
            }
        }
    }, {
        key: 'validateChosenOptionCategoryFails',
        value: function validateChosenOptionCategoryFails(chosenOptions) {

            var baseRequiredOptions = this.state.requiredOptions;

            return baseRequiredOptions.some(function (option) {
                var key = option.category;
                var idx = _lodash2.default.findIndex(chosenOptions, function (cOption) {
                    return cOption.category.trim() == key.trim();
                });

                if (idx === -1) {
                    return true;
                }

                var cOption = chosenOptions[idx];
                var cOptionLen = cOption.selectedKeys.length;

                if (!(cOptionLen >= option.minChoose && cOptionLen <= option.maxChoose)) {
                    return true;
                }
                return false;
            });
        }
    }, {
        key: 'generateStillRequiredOptions',
        value: function generateStillRequiredOptions(chosenOptions) {
            var baseRequiredOptions = this.state.requiredOptions;
            var stillRequiredOptions = [];

            baseRequiredOptions.forEach(function (option) {
                var key = option.category;
                var idx = _lodash2.default.findIndex(chosenOptions, function (cOption) {
                    return cOption.category.trim() == key.trim();
                });

                if (idx === -1) {
                    stillRequiredOptions.push(option);
                } else {
                    var cOption = chosenOptions[idx];
                    var cOptionLen = cOption.selectedKeys.length;

                    if (!(cOptionLen >= option.minChoose && cOptionLen <= option.maxChoose)) {
                        stillRequiredOptions.push(option);
                    }
                }
            });

            return stillRequiredOptions;
        }
    }, {
        key: 'calculateUnitPrice',
        value: function calculateUnitPrice(chosenOptions) {
            var unitPrice = this.props.item.itemPrice;
            var optionCategories = this.props.item.optionCategories || [];

            chosenOptions.forEach(function (cOption) {
                var key = cOption.category;
                var idx = _lodash2.default.findIndex(optionCategories, function (option) {
                    return option.category.trim() == key.trim();
                });
                var additionalPrice = 0.0;

                cOption.selectedKeys.forEach(function (val) {
                    if (optionCategories[idx].options) {
                        var optionObject = optionCategories[idx].options.find(function (x) {
                            return _lodash2.default.keys(x)[0] === val;
                        });
                        additionalPrice += optionObject[val].price;
                    } else {
                        additionalPrice += optionCategories[idx][val];
                    }
                });

                unitPrice += additionalPrice;
            });
            return unitPrice;
        }
    }, {
        key: 'getPriorDataForChosenOptions',
        value: function getPriorDataForChosenOptions(option) {
            if (this.isItemInCart()) {
                if (this.state.dpChosenOptions != null) {
                    var priorData = _lodash2.default.find(this.state.dpChosenOptions, function (chosen) {
                        return chosen.category == option.category;
                    });
                    return priorData;
                }
            } else {
                if (this.state.chosenOptions != null) {
                    var _priorData = _lodash2.default.find(this.state.chosenOptions, function (chosen) {
                        return chosen.category == option.category;
                    });
                    return _priorData;
                }
            }
        }
    }, {
        key: 'bringFocus',
        value: function bringFocus() {
            this.myTextArea.focus();
            this.setState({ setDataModalAutoFocus: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var self = this;
            var options = this.props.item.optionCategories || [];
            var id = this.props.item.objectId;

            var itemQty = this.isItemInCart() ? this.state.dpItemQty : this.state.itemQty;
            var itemPrice = this.isItemInCart() ? this.state.dpItemPrice : this.state.itemPrice;
            var itemOrderInst = this.isItemInCart() ? this.state.dpItemOrderInst : this.state.itemOrderInst;
            var chosenOptions = this.isItemInCart() ? this.state.dpChosenOptions : this.state.chosenOptions;

            var optionNodes = options.map(function (option, idx) {
                var priorData = self.getPriorDataForChosenOptions(option);
                return _react2.default.createElement(GenerateItemOptions, {
                    key: id + idx,
                    data: option,
                    priorData: priorData,
                    callbackParent: self.onItemOptionCategoryChanged
                });
            });

            var errorNodes = _react2.default.createElement(
                'div',
                { className: 'alert alert-warning', role: 'alert' },
                _react2.default.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign', 'aria-hidden': 'true' }),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    'Error:'
                ),
                'Please select ',
                _react2.default.createElement(
                    'b',
                    null,
                    'required'
                ),
                ' options for',
                _react2.default.createElement(
                    'b',
                    null,
                    this.state.stillRequiredOptions.map(function (requiredOptions) {
                        return ' ' + requiredOptions.category + ' ';
                    }).join(",")
                ),
                'to proceed.'
            );

            var modalDailogClass = "";
            var modalDailogClassChild = "";
            var ItemPopupHeight = "";
            var showBackgroundImg = false;

            if (this.props.imgAvailable) {
                modalDailogClass = "modal-dialog modal-dialog-add-item modal-lg modal-xl";
                modalDailogClassChild = "col-lg-6 col-md-12 remove-padding-left" + " d-inline-block remove-padding-right";
                ItemPopupHeight = "scroll-bar-wrap-img";
                showBackgroundImg = true;
            } else {
                modalDailogClass = "modal-dialog modal-dialog-add-item";
                modalDailogClassChild = "remove-padding-left remove-padding-right";
                ItemPopupHeight = "scroll-bar-wrap";
                showBackgroundImg = false;
            }

            var comp = "";

            if (this.state.isOrderSchedulingActive) {
                var locDetail = _MainStore2.default.getActiveLocation();

                comp = _react2.default.createElement(_ScheduleOrderModal2.default, {
                    callBackParent: this.handleScheduleScreenModal,
                    history: this.props.history,
                    locId: locDetail.objectId
                });
            } else {
                comp = _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: modalDailogClass, role: 'document' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-content modal-content-add-item' },
                            _react2.default.createElement(
                                'div',
                                { className: "modal-body modal-body-item row" },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-lg-12' },
                                    showBackgroundImg ? _react2.default.createElement('div', {
                                        className: "col-lg-6 col-md-12 remove-padding-left" + " d-inline-block remove-padding-right" + " background-item-img",
                                        style: {
                                            backgroundImage: 'url(' + this.props.itemImageURL + ')',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center center',
                                            backgroundRepeat: 'no-repeat'
                                        } }) : null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: modalDailogClassChild,
                                            style: { top: "-35px" }
                                        },
                                        _react2.default.createElement(
                                            'div',
                                            { className: ItemPopupHeight },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'scroll-box', id: "scroll-box" },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'item_summary' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        null,
                                                        _react2.default.createElement(
                                                            'h3',
                                                            { className: 'itemName padding-left-right d-inline-block mb-2 mt-3 font-weight-bold' },
                                                            this.props.item.itemName
                                                        ),
                                                        _react2.default.createElement(
                                                            'button',
                                                            {
                                                                type: 'button',
                                                                className: 'close close-button-item-add',
                                                                'data-dismiss': 'modal',
                                                                'aria-label': 'Close',
                                                                onClick: this.props.handleHideModal

                                                                // style={{top: "67px", left: "88%"}}
                                                            },
                                                            _react2.default.createElement('img', { src: _cancelButton2.default,
                                                                className: 'cancelButton', alt: "Close Popup" })
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'padding-left-right mt-1' },
                                                        _react2.default.createElement(
                                                            'h6',
                                                            { className: 'color-styl' },
                                                            '$',
                                                            _lodash2.default.round(this.props.item.itemPrice, 2).toFixed(2)
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: "mb-3 text-gray padding-left-right" },
                                                        _react2.default.createElement(
                                                            'p',
                                                            { className: 'mb-0',
                                                                style: { whiteSpace: 'pre-wrap' } },
                                                            this.props.item.itemDescription
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'item_quantity padding-left-right' },
                                                        _react2.default.createElement(_Counter2.default, {
                                                            name: 'quantity',
                                                            min: '1',
                                                            max: '20',
                                                            currentValue: itemQty,
                                                            callbackParent: this.onQtySelectionChanged
                                                        })
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'form-group' },
                                                    this.state.isSelectionValid != null && this.validateChosenOptionCategoryFails(chosenOptions) ? errorNodes : null,
                                                    optionNodes
                                                ),
                                                _react2.default.createElement(
                                                    'label',
                                                    {
                                                        className: 'item-option-label',
                                                        htmlFor: 'spl_instructions'
                                                    },
                                                    'Special Item Instructions:'
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    {
                                                        className: 'special_instructions_text padding-left-right mb-10' },
                                                    _react2.default.createElement('textarea', {
                                                        className: 'form-control input-md item_form-textarea',
                                                        id: 'cart_item_special_instructions',
                                                        ref: function ref(_ref) {
                                                            _this2.myTextArea = _ref;
                                                        },
                                                        name: 'special_instructions',
                                                        placeholder: 'Special Instructions for Item',
                                                        title: "Special Instructions for Item",
                                                        rows: '4',
                                                        onChange: this.onTextAreaContentChanged,
                                                        value: itemOrderInst
                                                    })
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'bottom-add-button padding-left-right' },
                                            _react2.default.createElement(
                                                _SimpleButton2.default,
                                                {
                                                    classNames: 'themebtn fOrderBtn btn-block btn-styl button-right add-item-button ',
                                                    whenClicked: this.addUpdateItemToCart
                                                },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: "button_name" },
                                                    this.state.newOrder ? 'Add to Order' : 'Update'
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'base_item_price' },
                                                    _react2.default.createElement(
                                                        'p',
                                                        {
                                                            className: 'base_item_price-text button_name',
                                                            'data-use-currency': 'false',
                                                            id: 'offer_base'
                                                        },
                                                        '$',
                                                        _lodash2.default.round(itemPrice * itemQty, 2).toFixed(2)
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                );
            }
            return comp;
        }
    }, {
        key: 'handleScheduleScreenModal',
        value: function handleScheduleScreenModal(status) {
            var _this3 = this;

            // $("body").css("padding-right","0");
            //add modal-open class
            //on body tag
            if (status == false) {
                $('body').addClass("modal-open");
                // modalOpen.classList.add('modal-open');
            }

            this.setState({
                isOrderSchedulingActive: status
            }, function () {
                _this3.showOrderScheduleModal(false);
            });
        }
    }, {
        key: 'showOrderScheduleModal',
        value: function showOrderScheduleModal(status) {
            var itemModal = document.getElementById("itemOptionModal");

            if (status) {
                // $('#itemOptionModal').modal('hide');
                itemModal.style.display = "none";
            } else {
                // $('#itemOptionModal').modal('show');
                document.body.tabIndex = -1;
                itemModal.style.display = "block";
            }
        }
    }, {
        key: 'addUpdateItemToCart',
        value: function addUpdateItemToCart(event) {

            var self = this;
            // Update order function
            if (this.isItemInCart()) {

                var itemId = this.props.item.objectId;
                var updateObject = {
                    itemObjectId: itemId,
                    itemOrderInst: this.state.dpItemOrderInst,
                    itemPrice: this.state.dpItemPrice,
                    itemOptionCategories: this.state.dpChosenOptions,
                    itemQty: this.state.dpItemQty
                };

                var coData = this.state.dpChosenOptions;
                self.validateTheItemOrder(coData, updateObject);
            } else {

                var _itemId = this.props.item.objectId;
                var _updateObject = {
                    itemObjectId: _itemId,
                    itemOrderInst: this.state.itemOrderInst,
                    itemPrice: this.state.itemPrice,
                    itemOptionCategories: this.state.chosenOptions,
                    itemQty: this.state.itemQty
                };

                var _coData = this.state.chosenOptions;
                self.validateTheItemOrder(_coData, _updateObject);
            }

            // $('#itemOptionModal').modal('hide')
            // //hide modal backdrop
            // $('.modal-backdrop').remove();
        }
    }, {
        key: 'tabIndex',
        value: function tabIndex() {
            var div = document.getElementsByClassName("swal2-popup swal2-modal swal2-icon-warning swal2-show");
            // let order =document.querySelector('.swal2-popup');
            div.tabIndex = 10;
            // div.tabIndex = 6;
        }
    }, {
        key: 'validateTheItemOrder',
        value: function validateTheItemOrder(chosenOptionsData, updateObject) {
            var _this4 = this;

            var isSelectionInValid = this.validateChosenOptionCategoryFails(chosenOptionsData);

            if (isSelectionInValid) {

                var stillRequiredOptions = this.state.stillRequiredOptions;

                /* Getting the categoryid from every category and add the scroll */
                var currentError = stillRequiredOptions[0];
                var category = currentError.category;
                var categoryId = category.split(' ').join('_');
                var devElement = document.getElementById(categoryId);

                // check application running on web or mobile platform
                if ($(window).width() < 992) {

                    var topPos1 = devElement.offsetTop;

                    if (this.props.imgAvailable) {
                        var topPos1 = devElement.offsetTop + 100;
                    }

                    document.getElementById('itemOptionModal').scrollTo({ top: topPos1, behavior: 'smooth' });
                } else {
                    // scroll for web
                    var topPos = devElement.offsetTop;
                    document.getElementById('scroll-box').scrollTo({ top: topPos, behavior: 'smooth' });
                }

                // devElement.scrollIntoView({
                //     block: 'center',
                //     behavior: "smooth"
                // });

                this.setState({
                    isSelectionValid: !isSelectionInValid
                });

                // const msg = this.state.stillRequiredOptions.map(
                //     (requiredOptions) => ` ${requiredOptions.category} `
                // ).join(",");

                // alert(`Please select required options for ${msg} to proceed.`);

                return;
            }

            var scheduledDate = _ScheduleScreenStore2.default.getScheduledDate();

            // check the itemTaxId exist in the locationDetail.taxConfig

            if (_CartStore2.default.isItemTaxConfigured()) {

                var item = this.props.item;
                var itemTaxId = item.itemTaxId;
                if (item && itemTaxId != null) {

                    if (_CartStore2.default.checkItemTaxIdExistInTaxConfig(itemTaxId) != true) {

                        var activeLocation = _MainStore2.default.getActiveLocation();

                        var phoneNumber = Utils.formatPhoneNumber(activeLocation.phoneNumber);

                        var message = '\'' + item.itemName + '\' tax configuration is incorrect. This item can not be added to the cart, please let the restaurant know \'' + phoneNumber + '\' or email support@freshbytes.io';

                        //before opening sweetAlert close
                        //item modal
                        this.showOrderScheduleModal(true);

                        _sweetalert2.default.fire({
                            title: "Error",
                            text: message,
                            icon: 'warning',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'Close',
                            stopKeydownPropagation: false,
                            customClass: {
                                cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                            }
                        });

                        return;
                    }
                }
            }

            // Check the location open hours for DineIn orderTypes
            if (_MainStore2.default.isLocationForDineInOnly()) {

                var isDineInEnabled = _MainStore2.default.isDineInEnabled();

                if (isDineInEnabled) {

                    //before opening sweetAlert close
                    //item modal
                    this.showOrderScheduleModal(true);

                    var _message = this.validateDineInOpenHour(scheduledDate);
                    // let message = null;

                    if (_message) {
                        var _Swal$fire;

                        //before opening sweetAlert close
                        //item modal
                        this.showOrderScheduleModal(true);

                        _sweetalert2.default.fire((_Swal$fire = {
                            title: "Warning!",
                            text: _message,
                            icon: 'warning',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'Close'
                        }, _defineProperty(_Swal$fire, 'cancelButtonText', 'Close'), _defineProperty(_Swal$fire, 'customClass', {
                            cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                        }), _defineProperty(_Swal$fire, 'allowEscapeKey', "true"), _defineProperty(_Swal$fire, 'stopKeydownPropagation', false), _Swal$fire));

                        return;
                    } else {

                        this.addItemAfterSuccessValidation(updateObject);
                    }
                } else {
                    //before opening sweetAlert close
                    //item modal
                    this.showOrderScheduleModal(true);

                    var _message2 = "Dine-In ordering is disabled.";

                    _sweetalert2.default.fire({
                        title: "Dine-In Not Available",
                        text: _message2,
                        icon: 'warning',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'Close',
                        stopKeydownPropagation: false,
                        customClass: {
                            cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                        }
                    });

                    return;
                }
            } else {
                // Check the location open hours for Delivery, Pickup orderTypes
                var _validateOpenHour = this.validateOpenHour(scheduledDate),
                    title = _validateOpenHour.title,
                    msg = _validateOpenHour.msg;

                var self = this;

                if (msg) {
                    //before opening sweetAlert close
                    //item modal
                    this.showOrderScheduleModal(true);

                    _sweetalert2.default.fire({
                        title: title,
                        text: msg,
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        stopKeydownPropagation: false,
                        customClass: {
                            confirmButton: "bg-styl",
                            cancelButton: "swal2-confirm custom-btn-outline-primary custom-primary"
                        }

                    }).then(function (result) {
                        if (result.isConfirmed) {
                            // show the schedule screen modal
                            self.handleScheduleScreenModal(true);
                        } else {
                            _this4.props.handleHideModal();
                        }
                    });

                    return;
                } else {
                    this.addItemAfterSuccessValidation(updateObject);
                }
            }
        }
    }, {
        key: 'addItemAfterSuccessValidation',
        value: function addItemAfterSuccessValidation(update) {
            this.props.changeTitle();

            var itemId = this.props.item.objectId;
            // update functionality
            if (this.isItemInCart()) {
                var priorItemInCart = this.props.itemInCart;
                _Actions2.default.updateItemInCart(itemId, update, priorItemInCart);
            } else {
                _Actions2.default.addItemToCart(itemId, update, this.props.item);
            }

            this.props.handleHideModal();
            this.showMenuComp();

            // Reset the tabindex and again added to 3
            // tabindex 53 is used for the view cart screen
            document.body.tabIndex = 53;
            document.body.focus();
        }
    }, {
        key: 'showMenuComp',
        value: function showMenuComp() {
            var navBar = document.getElementById("navBarTop");
            var stickyBox = document.getElementById("sticky-box");
            var isMobile = this.state.isMobile;

            //on mobile if item modal is uppdated
            //show cart-header comp
            if (isMobile && stickyBox) {
                navBar.classList.add("nav-animate-up");
                navBar.classList.remove("nav-animate-down");
                navBar.classList.remove("collapsed");

                stickyBox.classList.remove("menu-animate-down");
                stickyBox.classList.add("menu-animate-up");
                stickyBox.style.top = "63px";
            }
        }
    }]);

    return ItemOptions;
}(_react2.default.Component);

var GenerateItemOptions = function (_React$Component2) {
    _inherits(GenerateItemOptions, _React$Component2);

    function GenerateItemOptions(props) {
        _classCallCheck(this, GenerateItemOptions);

        var _this5 = _possibleConstructorReturn(this, (GenerateItemOptions.__proto__ || Object.getPrototypeOf(GenerateItemOptions)).call(this, props));

        _this5.state = {
            selectedKeys: []
        };

        _this5.setSelectedOptions = _this5.setSelectedOptions.bind(_this5);
        return _this5;
    }

    _createClass(GenerateItemOptions, [{
        key: 'setSelectedOptions',
        value: function setSelectedOptions(selectedOption) {
            var _this6 = this;

            this.setState({
                selectedKeys: selectedOption
            }, function () {
                var obj = {
                    "category": _this6.props.data.category,
                    "selectedKeys": _this6.state.selectedKeys
                };

                _this6.props.callbackParent(obj);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            // let dataRows  = _.omit(this.props.data,['optionCategoryName','optionCategoryType']);
            var dataRows = this.props.data;

            var priorData = this.props.priorData != null ? this.props.priorData.selectedKeys : null;

            /* Adding div id as a category id for scroll to specific div*/
            var category = dataRows.category;
            var categoryId = category.split(' ').join('_');

            return _react2.default.createElement(
                'div',
                { id: categoryId },
                this.props.data.minChoose === 1 && this.props.data.maxChoose === 1 ? _react2.default.createElement(_Radio2.default, {
                    radioData: dataRows,
                    id: this.props.data.category,
                    priorRadioData: priorData,
                    label: this.props.data.category,
                    cssClass: "item-option-label",
                    callbackParent: this.setSelectedOptions
                }) : _react2.default.createElement(_Checkbox2.default, {
                    checkBoxData: dataRows,
                    id: this.props.data.category,
                    priorCheckBoxData: priorData,
                    label: this.props.data.category,
                    cssClass: "item-option-label",
                    callbackParent: this.setSelectedOptions
                })
            );
        }
    }]);

    return GenerateItemOptions;
}(_react2.default.Component);

// ItemOptions.contextTypes = {
//     router : React.PropTypes.object.isRequired
// }


exports.default = ItemOptions;


//////////////////
// WEBPACK FOOTER
// ./src/components/item-options.jsx
// module id = 480
// module chunks = 0